import React from 'react';
import {FormikContext} from 'formik';

function getValueByPath(source: any, path: string) {
 return String(path)
  .split('.')
  .reduce((value, key) => value?.[key], source);
}

export default function FormEffectNode({watch = [], effect, immediate = true}: any) {
 const formik: any = React.useContext(FormikContext as any);
 const fields = Array.isArray(watch) ? watch : [watch].filter(Boolean);
 const values = formik?.values || {};
 const dependencies = fields.map((field: string) => getValueByPath(values, field));
 const didRun = React.useRef(false);

 React.useEffect(() => {
  if (!immediate && !didRun.current) {
   didRun.current = true;
   return;
  }

  didRun.current = true;

  if (!formik || typeof effect !== 'function') return;

  effect({
   ...formik,
   values,
   watch: fields,
  });

  formik?.setStatus?.({
   ...(formik?.status || {}),
   __formEffectVersion: Date.now(),
  });
 }, dependencies);

 return null;
}
